import * as types from '../constants';

export function exportListToCSV(params, loadAdvanced = false, limit, total) {
  return {
    type: types.EXPORT_LIST_TO_CSV,
    params,
    loadAdvanced,
    limit,
    total,
  };
}

export function exportListToSplunk(params, loadAdvanced = false, limit) {
  return {
    type: types.EXPORT_LIST_TO_SPLUNK,
    params,
    loadAdvanced,
    limit,
  };
}

export function exportListToSTIX(params, loadAdvanced = false, limit, total) {
  return {
    type: types.EXPORT_LIST_TO_STIX,
    params,
    loadAdvanced,
    limit,
    total,
  };
}

export function exportListToSTIXLimited(params, limit) {
  return {
    type: types.EXPORT_LIST_TO_STIX_LIMITED,
    params,
    limit,
  };
}

export function resetStixExportLimitedStatus() {
  return {
    type: types.RESET_STIX_EXPORT_LIMITED_STATUS,
  };
}

export function exportListToJSON(params, loadAdvanced = false, limit, total) {
  return {
    type: types.EXPORT_LIST_TO_JSON,
    params,
    loadAdvanced,
    limit,
    total,
  };
}

export function exportSingleIOC(uuid) {
  return {
    type: types.EXPORT_SINGLE_IOC,
    uuid,
  };
}

export function exportExploreResultToCSV(path, limit, sort, filter) {
  return {
    type: types.EXPORT_EXPLORE_RESULT_TO_CSV,
    path,
    limit,
    sort,
    filter,
  };
}

export function exportExploreResultToJSON(path, limit, sort, filter) {
  return {
    type: types.EXPORT_EXPLORE_RESULT_TO_JSON,
    path,
    limit,
    sort,
    filter,
  };
}

export function exportSpoofingToCSV(
  domain,
  regex,
  name_servers,
  is_nameserver_in,
  additional_networks,
  is_network_in,
  as_numbers,
  is_asn_in,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
) {
  return {
    type: types.EXPORT_SPOOFING_TO_CSV,
    domain: domain,
    regex: regex,
    name_servers: name_servers,
    is_nameserver_in: is_nameserver_in,
    additional_networks: additional_networks,
    is_network_in: is_network_in,
    as_numbers: as_numbers,
    is_asn_in: is_asn_in,
    first_seen_before: first_seen_before,
    first_seen_after: first_seen_after,
    last_seen_before: last_seen_before,
    last_seen_after: last_seen_after,
    limit: limit,
    sort: sort,
  };
}

export function exportSpoofingToJSON(
  domain,
  regex,
  name_servers,
  is_nameserver_in,
  additional_networks,
  is_network_in,
  as_numbers,
  is_asn_in,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
) {
  return {
    type: types.EXPORT_SPOOFING_TO_JSON,
    domain: domain,
    regex: regex,
    name_servers: name_servers,
    is_nameserver_in: is_nameserver_in,
    additional_networks: additional_networks,
    is_network_in: is_network_in,
    as_numbers: as_numbers,
    is_asn_in: is_asn_in,
    first_seen_before: first_seen_before,
    first_seen_after: first_seen_after,
    last_seen_before: last_seen_before,
    last_seen_after: last_seen_after,
    limit: limit,
    sort: sort,
  };
}

export function exportDanglingDNSToCSV(record_type, source, limit, sort) {
  return {
    type: types.EXPORT_DANGLING_DNS_TO_CSV,
    record_type: record_type,
    source: source,
    limit: limit,
    sort: sort,
  };
}

export function exportDanglingDNSToJSON(record_type, source, limit, sort) {
  return {
    type: types.EXPORT_DANGLING_DNS_TO_JSON,
    record_type: record_type,
    source: source,
    limit: limit,
    sort: sort,
  };
}

export function exportHostingInfrasctructureASNsToCSV(
  result_format,
  domain,
  limit,
) {
  return {
    type: types.EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_CSV,
    result_format: result_format,
    domain: domain,
    limit: limit,
  };
}

export function exportHostingInfrasctructureASNsToJSON(
  result_format,
  domain,
  limit,
) {
  return {
    type: types.EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_JSON,
    result_format: result_format,
    domain: domain,
    limit: limit,
  };
}

export function exportSubdomainFinderToCSV(
  domain,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
) {
  return {
    type: types.EXPORT_SUBDOMAIN_FINDER_TO_CSV,
    domain: domain,
    first_seen_before: first_seen_before,
    first_seen_after: first_seen_after,
    last_seen_before: last_seen_before,
    last_seen_after: last_seen_after,
    limit: limit,
    sort: sort,
  };
}

export function exportSubdomainFinderToJSON(
  domain,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
) {
  return {
    type: types.EXPORT_SUBDOMAIN_FINDER_TO_JSON,
    domain: domain,
    first_seen_before: first_seen_before,
    first_seen_after: first_seen_after,
    last_seen_before: last_seen_before,
    last_seen_after: last_seen_after,
    limit: limit,
    sort: sort,
  };
}

export function exportShadowITtoCSV(
  domain,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
) {
  return {
    type: types.EXPORT_SHADOW_IT_TO_CSV,
    domain: domain,
    first_seen_before: first_seen_before,
    first_seen_after: first_seen_after,
    last_seen_before: last_seen_before,
    last_seen_after: last_seen_after,
    limit: limit,
    sort: sort,
  };
}

export function exportShadowITtoJSON(
  domain,
  first_seen_before,
  first_seen_after,
  last_seen_before,
  last_seen_after,
  limit,
  sort,
) {
  return {
    type: types.EXPORT_SHADOW_IT_TO_JSON,
    domain: domain,
    first_seen_before: first_seen_before,
    first_seen_after: first_seen_after,
    last_seen_before: last_seen_before,
    last_seen_after: last_seen_after,
    limit: limit,
    sort: sort,
  };
}

export function clearScoreDetails() {
  return {
    type: types.CLEAR_SCORE_DETAILS,
  };
}

export function clearExploreDetails() {
  return {
    type: types.CLEAR_EXPLORE_SCORE_DETAILS,
  };
}

export function loadScoreDetails(id, iocType) {
  return {
    type: types.LOAD_SCORE_DETAILS,
    id,
    iocType,
  };
}

//@TODO: for now only retrieves overlap and originator, will be expanded
export function loadNewScoreDetails(feed_uuid) {
  return {
    type: types.LOAD_NEW_SCORE_DETAILS,
    feed_uuid,
  };
}

export function toggleFalsePositive(ioc) {
  return {
    type: types.TOGGLE_FALSE_POSITIVE,
    // ioc_uuid,
    ioc,
  };
}

export function toggleTruePositive(ioc) {
  return {
    type: types.TOGGLE_TRUE_POSITIVE,
    // ioc_uuid,
    ioc,
  };
}

export function loadMergeAPIIPDetails(ip) {
  return {
    type: types.LOAD_MERGE_API_IP_SCORE_DETAILS,
    ip,
  };
}

export function loadMergeAPIDomainDetails(domain) {
  return {
    type: types.LOAD_MERGE_API_DOMAIN_SCORE_DETAILS,
    domain,
  };
}

export function loadMergeAPIExploreDetails(path) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_SCORE_DETAILS,
    path,
  };
}

export function loadNameServerAutoFill(path) {
  return {
    type: types.LOAD_NAME_SERVER_AUTOFILL,
    path,
  };
}

export function loadDnsRecords(path) {
  return {
    type: types.LOAD_DNS_RECORDS,
    path,
  };
}

export function loadARecordsDomainEnrichment(path) {
  return {
    type: types.LOAD_A_RECORDS_DOMAIN_ENRICHMENT,
    path,
  };
}

export function loadAAAARecordsDomainEnrichment(path) {
  return {
    type: types.LOAD_AAAA_RECORDS_DOMAIN_ENRICHMENT,
    path,
  };
}

export function loadCNAMERecordsDomainEnrichment(path) {
  return {
    type: types.LOAD_CNAME_RECORDS_DOMAIN_ENRICHMENT,
    path,
  };
}

export function loadMXRecordsDomainEnrichment(path) {
  return {
    type: types.LOAD_MX_RECORDS_DOMAIN_ENRICHMENT,
    path,
  };
}

export function loadNSRecordsDomainEnrichment(path) {
  return {
    type: types.LOAD_NS_RECORDS_DOMAIN_ENRICHMENT,
    path,
  };
}

export function loadSOARecordsDomainEnrichment(path) {
  return {
    type: types.LOAD_SOA_RECORDS_DOMAIN_ENRICHMENT,
    path,
  };
}

export function loadTXTRecordsDomainEnrichment(path) {
  return {
    type: types.LOAD_TXT_RECORDS_DOMAIN_ENRICHMENT,
    path,
  };
}

export function saveBreadCrumbs(data) {
  return {
    type: types.SAVE_BREADCRUMBS,
    data,
  };
}

export function loadIpDensity(ip) {
  return {
    type: types.LOAD_IP_DENSITY,
    ip: ip.ip,
    iocType: ip.iocType,
    is_voluntary: ip.is_voluntary,
  };
}

export function loadPTRLookup(ip) {
  return {
    type: types.LOAD_PTR_LOOKUP,
    ip: ip.ip,
    iocType: ip.iocType,
    is_voluntary: ip.is_voluntary,
  };
}

export function loadASNAutoFill(path) {
  return {
    type: types.LOAD_ASN_AUTOFILL,
    path,
  };
}

export function loadMergeAPIMergeDetails(path) {
  return {
    type: types.LOAD_MERGE_API_MERGE_SCORE_DETAILS,
    path,
  };
}

export function postMergeAPIExploreDetails(data, path) {
  return {
    type: types.POST_MERGE_API_EXPLORE_SCORE_DETAILS,
    data,
    path,
  };
}

export function postMergeAPIMergeDetails(data, path) {
  return {
    type: types.POST_MERGE_API_MERGE_SCORE_DETAILS,
    data,
    path,
  };
}

export function loadMergeAPIDomainInfraTags(domain, is_voluntary) {
  return {
    type: types.LOAD_MERGE_API_DOMAIN_INFRA_TAGS,
    domain,
    is_voluntary,
  };
}

export function loadMergeAPIExploreQueryBuilderSchemas() {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMAS,
  };
}

export function loadMergeAPIExploreQueryBuilderSchema(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
    uuid,
  };
}

export function loadAttackSurfaceMapping() {
  return {
    type: types.LOAD_ATTACK_SURFACE_MAPPING,
  };
}

export function loadDigitalThreatManagement() {
  return {
    type: types.LOAD_DIGITAL_THREAT_MANAGEMENT,
  };
}

export function loadMergeAPIExploreRecipes() {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPES,
  };
}

export function loadMergeAPIExploreRecipe(path) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE,
    path,
  };
}

export function loadMergeAPIRiskScores(data) {
  return {
    type: types.LOAD_MERGE_API_RISK_SCORES,
    data,
  };
}

export function loadMergeAPIASNDetails(data) {
  return {
    type: types.LOAD_MERGE_API_ASN_DETAILS,
    data,
  };
}

export function loadHistoryQueries(page, urlFilter, hoursFilter, sort, users) {
  return {
    type: types.LOAD_HISTORY_QUERIES,
    page,
    urlFilter,
    hoursFilter,
    sort,
    users,
  };
}

export function updateHistoryQuery(uuid, status, total_results) {
  return {
    type: types.UPDATE_HISTORY_QUERY,
    uuid: uuid,
    status: status,
    total_results: total_results,
  };
}

export function addNewHistoryQuery(
  uuid,
  url,
  origin_label,
  origin_uid,
  job_id,
  total_results,
  status,
  is_enabled,
  is_visualizable,
  created,
  executed_by,
) {
  return {
    type: types.ADD_NEW_HISTORY_QUERY,
    uuid: uuid,
    url: url,
    origin_label: origin_label,
    origin_uid: origin_uid,
    job_id: job_id,
    total_results: total_results,
    status: status,
    is_enabled: is_enabled,
    is_visualizable: is_visualizable,
    created: created,
    executed_by: executed_by,
  };
}

export function loadHistoryQueryResult(uuid) {
  return {
    type: types.LOAD_HISTORY_QUERY_RESULT,
    uuid,
  };
}

export function clearCopyHistoryQueryResult() {
  return {
    type: types.CLEAR_COPY_HISTORY_QUERY_RESULT,
  };
}

export function copyHistoryQueryResult(uuid) {
  return {
    type: types.COPY_HISTORY_QUERY_RESULT,
    uuid,
  };
}

export function downloadHistoryQueryResult(uuid) {
  return {
    type: types.DOWNLOAD_HISTORY_QUERY_RESULT,
    uuid,
  };
}

export function loadMonitoringQueries(page) {
  return {
    type: types.LOAD_MONITORING_QUERIES,
    page,
  };
}

export function saveMonitoringQuery(data) {
  return {
    type: types.SAVE_MONITORING_QUERY,
    data,
  };
}

export function updateMonitoringQuery(data) {
  return {
    type: types.UPDATE_MONITORING_QUERY,
    data,
  };
}

export function deleteMonitoringQuery(uuid) {
  return {
    type: types.DELETE_MONITORING_QUERY,
    uuid,
  };
}

export function changeScopeMonitoringQuery(data) {
  return {
    type: types.CHANGE_SCOPE_MONITORING_QUERY,
    data,
  };
}

export function runMonitoringQuery(uuid) {
  return {
    type: types.RUN_MONITORING_QUERY,
    uuid,
  };
}

export function loadMonitoringQueryResultsHistory(uuid) {
  return {
    type: types.LOAD_MONITORING_QUERY_RESULTS_HISTORY,
    uuid,
  };
}

export function saveMergeAPIExploreQueryBuilderSchema(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
    data,
  };
}

export function deleteMergeAPIExploreQueryBuilderSchema(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
    uuid,
  };
}

export function changeScopeMergeAPIExploreQueryBuilderSchema(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
    data,
  };
}

export function resetFilterProfile() {
  return {
    type: types.RESET_FILTER_PROFILE,
  };
}

export function resetRecipeStatus() {
  return {
    type: types.RESET_RECIPE_STATUS,
  };
}

export function resetASNautofillStatus() {
  return {
    type: types.RESET_ASN_AUTOFILL_STATUS,
  };
}

export function resetEnrichment() {
  return {
    type: types.RESET_ENRICHMENT_STATUS,
  };
}

export function loadMergeAPIExploreRecipeForwardA(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_FORWARD_A,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeForwardA(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A,
    data,
  };
}

export function deleteMergeAPIExploreRecipeForwardA(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_FORWARD_A,
    uuid,
  };
}

export function saveMergeAPIExploreRecipeForwardA(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeForwardA(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_FORWARD_A,
    data,
  };
}

export function loadMergeAPIExploreRecipeNameServerChanges(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    uuid,
  };
}

export function loadMergeAPIExploreRecipeHostingInfraIPs(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeHostingInfraIPs(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
    data,
  };
}

export function deleteMergeAPIexploreRecipeHostingInfraIPs(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
    uuid,
  };
}

export function saveMergeAPIExploreRecipeHostingInfraIPs(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeHostingInfraIPs(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
    data,
  };
}

export function updateMergeAPIExploreRecipeNameServerChanges(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    data,
  };
}

export function deleteMergeAPIExploreRecipeNameServerChanges(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    uuid,
  };
}

export function saveMergeAPIExploreRecipeNameServerChanges(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeNameServerChanges(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    data,
  };
}

export function loadHostingInfrastructureASNData(path) {
  return {
    type: types.LOAD_HOSTING_INFRASTRUCTURE_ASN_DATA,
    path,
  };
}

export function loadMergeAPIExploreRecipeHostingInfrastructureASNs(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeHostingInfrastructureASNs(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    data,
  };
}

export function deleteMergeAPIExploreRecipeHostingInfrastructureASNs(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    uuid,
  };
}

export function saveMergeAPIExploreRecipeHostingInfrastructureASNs(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeHostingInfrastructureASNs(
  data,
) {
  return {
    type:
      types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    data,
  };
}

export function loadDanglingDNSRecordsCountData(path) {
  return {
    type: types.LOAD_DANGLING_DNS_RECORDS_COUNT_DATA,
    path,
  };
}

export function loadMergeAPIExploreRecipeDanglingDNSRecordsCount(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeDanglingDNSRecordsCount(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    data,
  };
}

export function deleteMergeAPIExploreRecipeDanglingDNSRecordsCount(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    uuid,
  };
}

export function saveMergeAPIExploreRecipeDanglingDNSRecordsCount(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeDanglingDNSRecordsCount(data) {
  return {
    type:
      types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    data,
  };
}

export function loadDanglingDNSProtectionData(path) {
  return {
    type: types.LOAD_DANGLING_DNS_PROTECTION_DATA,
    path,
  };
}

export function loadMergeAPIExploreRecipeDanglingDNSProtection(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeDanglingDNSProtection(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    data,
  };
}

export function deleteMergeAPIExploreRecipeDanglingDNSProtection(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    uuid,
  };
}

export function saveMergeAPIExploreRecipeDanglingDNSProtection(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeDanglingDNSProtection(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    data,
  };
}

export function loadMergeAPIExploreRecipeTXT(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_TXT,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeTXT(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_TXT,
    data,
  };
}

export function deleteMergeAPIExploreRecipeTXT(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_TXT,
    uuid,
  };
}

export function saveMergeAPIExploreRecipeTXT(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_TXT,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeTXT(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_TXT,
    data,
  };
}

export function loadMergeAPIExploreRecipeIPDiversity(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
    uuid,
  };
}

export function deleteMergeAPIExploreRecipeIPDiversity(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeIPDiversity(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
    data,
  };
}

export function saveMergeAPIExploreRecipeIPDiversity(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeIPDiversity(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
    data,
  };
}

export function loadMergeAPIExploreRecipeLatestDNSRecords(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    uuid,
  };
}

export function deleteMergeAPIExploreRecipeLatestDNSRecords(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeLatestDNSRecords(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    data,
  };
}

export function saveMergeAPIExploreRecipeLatestDNSRecords(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeLatestDNSRecords(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    data,
  };
}

export function loadMergeAPIExploreRecipeSubdomainFinder(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
    uuid,
  };
}

export function deleteMergeAPIExploreRecipeSubdomainFinder(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeSubdomainFinder(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
    data,
  };
}

export function saveMergeAPIExploreRecipeSubdomainFinder(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeSubdomainFinder(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
    data,
  };
}

export function loadMergeAPIExploreRecipeShadowIT(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_SHADOW_IT,
    uuid,
  };
}

export function deleteMergeAPIExploreRecipeShadowIT(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeShadowIT(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT,
    data,
  };
}

export function saveMergeAPIExploreRecipeShadowIT(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeShadowIT(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT,
    data,
  };
}

export function loadMergeAPIExploreRecipeReverseA(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_REVERSE_A,
    uuid,
  };
}

export function deleteMergeAPIExploreRecipeReverseA(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_REVERSE_A,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeReverseA(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A,
    data,
  };
}

export function saveMergeAPIExploreRecipeReverseA(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeReverseA(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_REVERSE_A,
    data,
  };
}

export function loadMergeAPIExploreRecipeDomainsOnServer(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeDomainsOnServer(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
    data,
  };
}

export function deleteMergeAPIExploreRecipeDomainsOnServer(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
    uuid,
  };
}

export function saveMergeAPIExploreRecipeDomainsOnServer(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeDomainsOnServer(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
    data,
  };
}

export function loadMergeAPIExploreRecipeSpoofing(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_SPOOFING,
    uuid,
  };
}

export function deleteMergeAPIExploreRecipeSpoofing(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_SPOOFING,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeSpoofing(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeSpoofing(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SPOOFING,
    data,
  };
}

export function saveMergeAPIExploreRecipeSpoofing(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING,
    data,
  };
}

export function loadMergeAPIExploreRecipeNameInTXT(uuid) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
    uuid,
  };
}

export function deleteMergeAPIExploreRecipeNameInTXT(uuid) {
  return {
    type: types.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
    uuid,
  };
}

export function updateMergeAPIExploreRecipeNameInTXT(data) {
  return {
    type: types.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
    data,
  };
}

export function changeScopeMergeAPIExploreRecipeNameInTXT(data) {
  return {
    type: types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
    data,
  };
}

export function saveMergeAPIExploreRecipeNameInTXT(data) {
  return {
    type: types.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
    data,
  };
}

export function queryNameInTXTRecipe(data) {
  return {
    type: types.QUERY_NAME_IN_TXT_RECIPE,
    data,
  };
}

export function cloneRecipe(data, name, uuid) {
  return {
    type: types.CLONE_RECIPE,
    data,
    name,
    uuid,
  };
}

export function loadMonitoringFile(uuid) {
  return {
    type: types.LOAD_MONITORING_FILE,
    uuid,
  };
}

export function loadMonitoringJSONFile(uuid) {
  return {
    type: types.LOAD_MONITORING_JSON_FILE,
    uuid,
  };
}

export function loadIOCSFromSpecificCollection(uuid) {
  return {
    type: types.LOAD_IOCS_FROM_SPECIFIC_COLLECTION,
    uuid,
  };
}
export function loadIOCSPageFromSpecificCollection(uuid, page) {
  return {
    type: types.LOAD_IOCS_PAGE_FROM_SPECIFIC_COLLECTION,
    uuid,
    page,
  };
}

export function loadIOCSFromSpecificSharedCollection(uuid) {
  return {
    type: types.LOAD_IOCS_FROM_SPECIFIC_SHARED_COLLECTION,
    uuid,
  };
}

export function loadMergeAPIExploreAnyIPDetails(
  path1,
  path2,
  exploreFilters,
  exploreSorting,
) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_ANYIP_SCORE_DETAILS,
    path1,
    path2,
    exploreFilters,
    exploreSorting,
  };
}

export function loadMergeAPIExploreDensity(path) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_DENSITY_DETAILS,
    path,
  };
}

export function loadMergeAPIExploreIPDensity(path) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_IP_DENSITY_DETAILS,
    path,
  };
}

export function loadMergeAPIWhoisDetails(path) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_WHOIS_DETAILS,
    path,
  };
}

export function loadMergeAPIWhoisFallbackDetails(path) {
  return {
    type: types.LOAD_MERGE_API_EXPLORE_WHOIS_FALLBACK_DETAILS,
    path,
  };
}

export function loadMergeAPIEnrichment(data) {
  return {
    type: types.LOAD_MERGE_API_ENRICHMENT_SCORE_DETAILS,
    data,
  };
}

export function loadMergeAPINewEnrichment(name) {
  return {
    type: types.LOAD_MERGE_API_NEW_ENRICHMENT_SCORE_DETAILS,
    name: name.name,
    iocType: name.iocType,
  };
}

export function loadUtilsParseIOC(ioc) {
  return {
    type: types.LOAD_UTILS_PARSE_IOC,
    ioc,
  };
}

export function resetUtilsParseIOCStatus() {
  return {
    type: types.RESET_UTILS_PARSE_IOC_STATUS,
  };
}

export function createIOC(data) {
  return {
    type: types.CREATE_IOC,
    data,
  };
}

export function loadIOCNotes(iocUUID, feedUUID) {
  return {
    type: types.LOAD_IOC_NOTES,
    iocUUID,
    feedUUID,
  };
}

export function deleteIOCNote(iocUUID, noteUUID) {
  return {
    type: types.DELETE_IOC_NOTE,
    iocUUID,
    noteUUID,
  };
}

export function createIOCNote(noteDescription, iocUUID, feedUUID) {
  return {
    type: types.CREATE_IOC_NOTE,
    noteDescription,
    iocUUID,
    feedUUID,
  };
}

export function updateIOCNote(iocUUID, noteUUID, noteDescription) {
  return {
    type: types.UPDATE_IOC_NOTE,
    iocUUID,
    noteUUID,
    noteDescription,
  };
}

export function deleteIOC(uuid, feed) {
  return {
    type: types.DELETE_IOC,
    uuid,
    feed,
  };
}

export function deleteIOCFromCollection(uuid, feed) {
  return {
    type: types.DELETE_IOC_FROM_COLLECTION,
    uuid,
    feed,
  };
}

export function updateDistinct(distinct) {
  return {
    type: types.UPDATE_DISTINCT,
    distinct,
  };
}

export function loadBrandImpersonationRecipeResults(path) {
  return {
    type: types.LOAD_BRAND_IMPERSONATION_RECIPE_RESULTS,
    path,
  };
}

export function loadHostingInfrastructureASNsRecipeResults(path) {
  return {
    type: types.LOAD_HOSTING_INFRASTRUCTURE_ASNS_RECIPE_RESULTS,
    path,
  };
}

export function loadDanglingDNSDetectionRecipeResults(path) {
  return {
    type: types.LOAD_DANGLING_DNS_DETECTION_RECIPE_RESULTS,
    path,
  };
}

export function loadHostingInfrastructureIPsRecipeResults(path) {
  return {
    type: types.LOAD_HOSTING_INFRASTRUCTURE_IPS_RECIPE_RESULTS,
    path,
  };
}

export function loadShadowITRecipeResults(path) {
  return {
    type: types.LOAD_SHADOW_IT_RECIPE_RESULTS,
    path,
  };
}

export function loadSubdomainFinderRecipeResults(path) {
  return {
    type: types.LOAD_SUBDOMAIN_FINDER_RECIPE_RESULTS,
    path,
  };
}

export function setFeedStateFilter(data) {
  return {
    type: types.SET_FEED_STATE_FILTER,
    data,
  };
}

export function setClearRecipe() {
  return {
    type: types.SET_CLEAR_RECIPE,
  };
}

export function unsetClearRecipe() {
  return {
    type: types.UNSET_CLEAR_RECIPE,
  };
}
